import BuildingRoomContainer from 'containers/BuildingRoomContainer';

type Props = {};

export default function BuildingRoomPage({}: Props) {
  return <BuildingRoomContainer />;
}
